import React, { useEffect, useState } from "react";
import styles from "../styles/Usuarios.module.css";
import NuevoUsuarioModal from "./NuevoUsuarioModal";
import { validarSesion, fetchUsers, handleDeleteUser, handleEditUser } from "../handlers/usuarios";

const Usuarios = () => {
  const token = localStorage.getItem("token");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Estados para paginación y ordenamiento
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortField, setSortField] = useState("username");
  const [sortOrder, setSortOrder] = useState("asc");
  // Estado para mostrar el modal
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
  const checkSession = async () => {
    const activa = await validarSesion(token);
    if (!activa) {
      alert("Sesión expirada. Por favor, inicia sesión nuevamente.");
      window.location.href = "/";
    }
  };
  checkSession();
}, [token]);

  useEffect(() => {
    fetchUsers(token, setUsers, setLoading);
    // eslint-disable-next-line
  }, [token]);
  
  // Ordenamiento
  const sortedUsers = [...users].sort((a, b) => {
    if (a[sortField] < b[sortField]) return sortOrder === "asc" ? -1 : 1;
    if (a[sortField] > b[sortField]) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });

  // Paginación
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedUsers.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(users.length / rowsPerPage);

  // Cambiar orden
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  // Cambiar cantidad de filas
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <div className={styles.usuariosContainer}>
      <h3 className={styles.tituloUsuarios}>👥 Listado de Usuarios</h3>
        <button
          className={styles.iconButton}
          onClick={() => setShowModal(true)}
          title="Agregar nuevo usuario"
        >
          ➕
        </button>
        <NuevoUsuarioModal
          show={showModal}
          onClose={() => setShowModal(false)}
          onUserAdded={() => fetchUsers(token, setUsers, setLoading)}
        />

      {loading ? (
        <p>Cargando...</p>
      ) : users.length === 0 ? (
        <p>No hay usuarios para mostrar.</p>
      ) : (
        <>
          <table className={styles.table}>
            <thead>
              <tr>
                <th
                  className={`${styles.th} ${
                    sortField === "username" ? styles.sorted : ""
                  }`}
                  onClick={() => handleSort("username")}
                >
                  Usuario{" "}
                  {sortField === "username"
                    ? sortOrder === "asc"
                      ? "▲"
                      : "▼"
                    : "⇅"}
                </th>
                <th
                  className={`${styles.th} ${
                    sortField === "full_name" ? styles.sorted : ""
                  }`}
                  onClick={() => handleSort("full_name")}
                >
                  Nombre completo{" "}
                  {sortField === "full_name"
                    ? sortOrder === "asc"
                      ? "▲"
                      : "▼"
                    : "⇅"}
                </th>
                <th
                  className={`${styles.th} ${
                    sortField === "mail" ? styles.sorted : ""
                  }`}
                  onClick={() => handleSort("mail")}
                >
                  Correo{" "}
                  {sortField === "mail"
                    ? sortOrder === "asc"
                      ? "▲"
                      : "▼"
                    : "⇅"}
                </th>
                <th
                  className={`${styles.th} ${
                    sortField === "profile_id" ? styles.sorted : ""
                  }`}
                  onClick={() => handleSort("profile_id")}
                >
                  Perfil{" "}
                  {sortField === "profile_id"
                    ? sortOrder === "asc"
                      ? "▲"
                      : "▼"
                    : "⇅"}
                </th>
                <th
                  className={`${styles.th} ${
                    sortField === "created_at" ? styles.sorted : ""
                  }`}
                  onClick={() => handleSort("created_at")}
                >
                  Fecha creación{" "}
                  {sortField === "created_at"
                    ? sortOrder === "asc"
                      ? "▲"
                      : "▼"
                    : "⇅"}
                </th>
                <th
                  className={`${styles.th} ${
                    sortField === "updated_at" ? styles.sorted : ""
                  }`}
                  onClick={() => handleSort("updated_at")}
                >
                  Fecha actualización{" "}
                  {sortField === "updated_at"
                    ? sortOrder === "asc"
                      ? "▲"
                      : "▼"
                    : "⇅"}
                </th>
                <th className={styles.th}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {currentRows.map((user) => (
                <tr key={user.id}>
                  <td className={styles.td}>{user.username}</td>
                  <td className={styles.td}>{user.full_name}</td>
                  <td className={styles.td}>{user.mail}</td>
                  <td className={styles.td}>{user.profile_id}</td>
                  <td className={styles.td}>{user.created_at}</td>
                  <td className={styles.td}>{user.updated_at}</td>
                  <td className={styles.td}>
                    <button
                      className={styles.actionButton}
                      onClick={() => handleEditUser(user)}
                      title="Editar usuario"
                    >
                      ✏️
                    </button>
                    <button
                      className={styles.actionButton}
                      onClick={() => handleDeleteUser(user.id, token, fetchUsers)}
                      title="Eliminar usuario"
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className={styles.rowsPerPage}>
            <select value={rowsPerPage} onChange={handleRowsPerPageChange}>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
          </div>
          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <button
              className={styles.pagingButton}
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              ←
            </button>
            <span>
              Página {currentPage} de {totalPages}
            </span>
            <button
              className={styles.pagingButton}
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              →
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Usuarios;